import { Trans, useTranslation }         from 'react-i18next'
import {
  Box, Button,
  Collapse,
  Container,
  Grid,
  IconButton,
  Link,
  Stack,
  Typography
}                                        from '@mui/material'
import BaseTable                         from '../ui/components/base-table'
import { useApi }                        from '../utils/api'
import React, { useEffect, useState }    from 'react'
import { fDateTime }                     from '../utils/textutils'
import Page                              from '../ui/components/Page'
import { BaseBreadcrumbs }               from '../ui/components/BaseBreadcrumbs'
import { Link as RouterLink, useParams } from 'react-router-dom'
import palette                           from '../ui/theme/palette'
import Iconify                           from '../ui/components/Iconify'
import ShortFormControl                  from '../ui/components/short-form-control'
import { DateTime }                      from 'luxon'
import { useSnackbar }                   from 'notistack'

export default function OperatorsPage () {

  const { t } = useTranslation()
  const api = useApi()

  const columns = [
    { field: 'id', headerName: t('ID'), flex: 1, sortable: false, filterable: false },
    { field: 'name', headerName: t('Tel. From'), flex: 3, sortable: false, filterable: false },
  ]

  return (<Page title={t('Operators')}>
    <Container>
      <BaseBreadcrumbs key={'breadcrumb-operators'}
                       title={t('Operators')}
                       items={[]}/>
      <Grid container>
        <Grid item xs={12}>
          <Stack direction={'row'} spacing={2} alignItems={'baseline'} mb={2}>
            <Typography variant={'h4'}>{t('Operators')}</Typography>
          </Stack>
        </Grid>
      </Grid>
      <BaseTable
        columns={columns}
        loadCallback={async (query, page, pageSize) => {
          try {
            return await api.operator.list()
          } catch (e) {
            console.log('Failed to load operators', e)
            return {
              data: [],
              totalCount: 0,
            }
          }
        }}
      />
    </Container>
  </Page>)
}